import axios from "axios";
import { Config } from "../config";

const config = new Config();
const appBearer = {
  headers: { Authorization: config.settings.AppBearer },
};

const appBearer2 = {
  headers: { Authorization: config.settings.MediaApiBearer },
};

const api = axios.create({
  baseURL: config.settings.AppApiUrl,
});

const mediaApi = axios.create({
  baseURL: config.settings.MediaApiUrl,
});

export const getFeatureViewList = async () => {
  const res = await api.post("v1/features", {}, appBearer);
  return res.data;
};

export const getClientFlowList = async (
  featureId: number,
  clientCode: string
) => {
  const res = await api.get(
    `v1/feature/getClientFlows?featureId=${featureId}${
      clientCode ? `&clientCode=${clientCode}` : ""
    }`,
    appBearer
  );
  return res.data;
};

export const getClientsList = async () => {
  const res = await api.get(`v1/clients/GetAllClients`, appBearer);
  return res.data;
};

export const upsertClientFlows = async (data: any) => {
  const res = await api.post(`v1/writingAssistant/upsertFlow`, data, appBearer);
  return res.data;
};

export const getFlowActionsList = async (flowId: number) => {
  const res = await api.get(
    `v1/actions/flowActions?flowId=${flowId}`,
    appBearer
  );
  return res.data;
};

export const getModelsList = async (clientCode: string) => {
  const res = await api.get(
    `v1/masterLists/get?clientCode=${clientCode}&lists=model`,
    appBearer
  );
  return res.data;
};

export const upsertFlowAction = async (data: any, flowId: number) => {
  const res = await api.post(
    `v1/writingAssistant/upsertAction?flowId=${flowId}`,
    data,
    appBearer
  );
  return res.data;
};

export const getActionDetails = async (actionId: number) => {
  const res = await api.get(`v1/action/get?actionId=${actionId}`, appBearer);
  return res.data;
};

export const getDeleteFlow = async (clientCode: string, flowId: number) => {
  const res = await api.delete(
    `v1/writingAssistant/DeleteFlow?clientCode=${clientCode}&flowId=${flowId}`,
    appBearer
  );
  return res.data;
};

export const getDeleteFlowAction = async (actionId:number) => {
  const res = await api.delete(
    `v1/writingAssistant/DeleteFlowAction?actionId=${actionId}`,
    appBearer
  );
  return res.data;
};

export const getWritingAssistantFlowsList = async () => {
  const res = await api.get(`v1/wa/GetWritingAssistantFlows`, appBearer);
  return res.data;
};

export const getCloneOfFlow = async (flowId: number,  clientCode: string) => {
  const res = await api.post(`v1/wa/CloneFlow?flowId=${flowId}&clientCode=${clientCode}`, {}, appBearer);
  return res.data;
};

export const getMediaLibraryIcon= async (clientCode: any) => {
  return mediaApi.get(`v1/${clientCode}/media-library/ai/icons`,appBearer2).then(response => response.data);
};

export const getActionGroups = async (flowId: number) => {
  const res = await api.get(`v1/actionGroups/${flowId}`,appBearer);
  return res.data;
};

export const AddActionGroups = async (data:any) => {
  const res = await api.post(`v1/actionGroups/Upsert`,data,appBearer);
  return res.data;
};

export const getDeleteActionGroup = async (actionGroupId:number) => {
  const res = await api.delete(
    `v1/actionGroups/Delete?actionGroupId=${actionGroupId}`,
    appBearer
  );
  return res.data;
};
